import store from "@/store/";
import { USERINFO, TOKEN, ISIFRAME } from "@/store/mutation-types";
import { ls } from "@/utils/cache";

export default function Initializer() {
  const userInfo = ls.get(USERINFO);
  store.commit("user/SET_USERINFO", userInfo);

  // const wechatInfo = ls.get(WECHATUSERINFO);
  // store.commit("SET_WECHATUSERINFO", wechatInfo);

  // const restInfo = ls.get(RESTAURANTINFO);
  // store.commit("SET_RESTAURANTINFO", restInfo);

  const isIframe = ls.get(ISIFRAME);
  store.commit("app/SET_ISIFRAME", isIframe || false);

  const token = ls.get(TOKEN);
  store.commit("user/SET_TOKEN", token);
  // if (token) {
  //   store.dispatch("user/getSystemParam");
  // }
}
